/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geowindowlabel2Inputs */

const en_geowindowlabel2 = /** @type {(inputs: Geowindowlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time window`)
};

const de_geowindowlabel2 = /** @type {(inputs: Geowindowlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "Time window" |
*
* @param {Geowindowlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geowindowlabel2 = /** @type {((inputs?: Geowindowlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geowindowlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geowindowlabel2(inputs)
	return de_geowindowlabel2(inputs)
});
export { geowindowlabel2 as "geoWindowLabel" }